import { render, staticRenderFns } from "./TabelaProcessosJudiciaisPf.vue?vue&type=template&id=53a7c20a&lang=pug"
import script from "./TabelaProcessosJudiciaisPf.vue?vue&type=script&lang=js"
export * from "./TabelaProcessosJudiciaisPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaProcessosJudiciaisPf.vue?vue&type=style&index=0&id=53a7c20a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports